module.exports = __webpack_public_path__ + "img/dropbox.1e05553f.png";